let reportFormPhotos = {
    $bestMessage: $('#js-photosBestMessage'),
    $button: $('#js-photosButton'),
    $buttonInput: $('#js-photosButtonInput'),
    $input: $('#js-photosInput'),
    $list: $('#js-photosList'),
    $location: $('#js-photosLocation'),            
    $photos: $('#js-photos'),
    fileTypePattern: /^image\/jp(e)?g$/,
    hasLocation: false,
    maxFileSize: (1024 * (1024 * 5)),
    maxPhotos: 4,
    messageConfirmRemove: _.template($('#js-photosMessageConfirmRemove').text()),
    messageErrorFileType: _.template($('#js-photosMessageErrorFileType').text()),
    messageErrorUpload: _.template($('#js-photosMessageErrorFileType').text()),
    numPhotos: 0,
    photos: [],
    template: _.template($('#js-photo').html()),

    init() {
        console.log('reportFormPhotos.init')

        if (window.File && window.FileList && window.FileReader && window.FormData) {
            this.$buttonInput.on('change', this.onFileSelect.bind(this))
            this.$list.on('photo:best', this.onPhotoBest.bind(this))
            this.$list.on('photo:failed', this.onPhotoFailed.bind(this))
            this.$list.on('photo:uploaded', this.onPhotoUploaded.bind(this))
            this.$list.on('photo:removed', this.onPhotoRemoved.bind(this))
            this.$list.on('click', '.js-photoBest', this.photo.onClickBest.bind(this))
            this.$list.on('click', '.js-photoRemove', this.photo.onClickRemove.bind(this))
        } else {
            alert('Het uploaden van foto\'s is helaas niet mogelijk met uw browser. Probeer het alstublieft nog eens met een modernere browser.')
        }
    },

    onFileSelect(e) {
        let files

        e.preventDefault()
        files = e.originalEvent.target.files

        _.each(files, (file) => {
            if (this.numPhotos < this.maxPhotos) {
                if (!file.type.match(this.fileTypePattern)) {
                    return alert(this.messageErrorFileType())
                }

                this.numPhotos++
                this.updateButton()
                this.upload(file)
            }
        })
    },

    onPhotoBest(e, token) {
        _.each(this.photos, (photo) => {
            photo.is_best = (photo.token === token)
        });

        this.updateBest()
        this.updateJson()
    },

    onPhotoFailed(e, filename) {
        alert(this.messageErrorUpload({filename: filename}))
        this.numPhotos--
        this.updateState()
    },

    onPhotoRemoved(e, token) {
        _.remove(this.photos, function (photo) {
            return (photo.token === token)
        });

        this.$list.children(`[data-token='${token}']`).remove()

        if (this.photos.length) {
            if (_.findIndex(this.photos, {is_best: true}) === -1) {
                this.photos[0].is_best = true
            }
        }

        this.numPhotos--
        this.updateState()
    },

    onPhotoUploaded(e, token, hasLocation) {
        let isFirst = (!this.photos.length)

        this.photos.push({
            has_location: hasLocation,
            is_best: isFirst,
            is_new: true,
            token: token
        })

        this.updateState()
    },

    updateBest() {
        let i

        if (this.photos.length) {
            i = _.findIndex(this.photos, {is_best: true})
            this.$list.children().removeClass('is-best')
            this.$list.children(`[data-token='${this.photos[i].token}']`).addClass('is-best')
        }
    },

    updateButton() {
        this.$button.prop('disabled', (this.numPhotos >= this.maxPhotos))
    },

    updateHasLocation() {
        let i

        if (this.photos.length) {
            i = _.findIndex(this.photos, {has_location: true})
            this.$photos[(i > -1) ? 'addClass' : 'removeClass']('has-location')
        } else {
            this.$photos.removeClass('has-location')
        }
    },

    updateJson() {
        console.log(this.photos)
        this.$input.val(JSON.stringify(this.photos))
    },

    updateState() {
        this.updateBest()
        this.updateHasLocation()
        this.updateJson()

        this.$photos[(this.numPhotos > 0) ? 'addClass' : 'removeClass']('has-photo');
        this.$photos[(this.numPhotos > 1) ? 'addClass' : 'removeClass']('has-photos');
    },

    upload(file) {
        let $photo
        let formData
        let size
        let xhr

        if (file.size > 1024000) {
            size = (Math.round((file.size / 1024 / 1024) * 10) / 10) + ' MB'
        } else {
            size = Math.round(file.size / 1024) + ' KB'
        }

        $photo = $(this.template({
            filename: file.name,
            size: size
        }))

        $.extend($photo, {
            onClickBest: this.photo.onClickBest,
            onClickRemove: this.photo.onClickRemove,
            onUploadComplete: this.photo.onUploadComplete,
            onUploadFailed: this.photo.onUploadFailed,
            onUploadProgress: this.photo.onUploadProgress
        })

        $photo.appendTo(this.$list)

        formData = new FormData();
        formData.append('photo', file)
        formData.append('MAX_FILE_SIZE', this.maxFileSize)
        formData.append('PHP_SESSION_UPLOAD_PROGRESS', 'photo_progress')

        xhr = $.ajax({
            contentType: false,
            data: formData,
            dataType: 'json',
            processData: false,
            type: 'POST',
            url: '/foto',
            xhr: function () {
                let xhr = $.ajaxSettings.xhr()

                if (xhr.upload) {
                    xhr.upload.addEventListener('progress', (e) => {
                        $photo.onUploadProgress(Math.ceil((e.loaded / e.total) * 100))
                    })
                }

                return xhr
            }
        })

        $.when(xhr).then(
            $photo.onUploadComplete.bind($photo),
            $photo.onUploadFailed.bind($photo)
        )
    },

    photo: {
        onClickBest(e) {
            let $photo
            let token

            e.preventDefault()
            $photo = $(e.currentTarget).closest('.js-photo')
            token = $photo.attr('data-token')
            $photo.trigger('photo:best', [token])
        },

        onClickRemove(e) {
            let $photo
            let token
            let xhr

            e.preventDefault()
            $photo = $(e.currentTarget).closest('.js-photo')
            token = $photo.attr('data-token')

            if (confirm(this.messageConfirmRemove())) {
                xhr = $.ajax({
                    dataType: 'json',
                    method: 'DELETE',
                    url: '/foto/' + token
                })

                $.when(xhr).then((e) => {
                    $photo.trigger('photo:removed', [token])
                })
            }
        },

        onUploadComplete(data, status) {
            const exif = data.exif_data
            let hasLocation = false

            if (exif.lat && exif.lng) {
                this.addClass('has-location')
                this.find('.js-photoLocation').attr('href', `https://maps.google.com/?q=${exif.lat},${exif.lng}`)
                hasLocation = true
            }

            this.addClass('is-complete')
            this.attr('data-token', data.photo.token)
            this.trigger('photo:uploaded', [ data.photo.token, hasLocation ])
        },

        onUploadFailed(response, status) {
            alert(response.responseJSON.photo[0])
            this.remove()
            this.trigger('photo:failed', [this.attr('data-filename')])
        },

        onUploadProgress(progress) {
            this.find('.js-photoProgress').css('width', progress + '%')
        },
    }
}

export default reportFormPhotos